import { Component, ChangeDetectionStrategy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMainService } from '../../../core/services/core/app-main.service';
import { Address } from '../../../core/api/models';
import { AnalyticsService } from '../../../core/services/shared/analytics.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  readonly analytics = inject(AnalyticsService);
  private appMainService = inject(AppMainService);

  mainAddress = signal<Address | null>(null);

  facebookUrl = signal<string>('#');
  twitterUrl = signal<string>('#');
  instagramUrl = signal<string>('#');

  ngOnInit(): void {
    this.appMainService.getMasterConfig().subscribe({
      next: (master) => {
        if (master?.appMain) {
          this.mainAddress.set(master.appMain.mainLocation?.address || null);
          this.facebookUrl.set(master.appMain.facebookInformation || '#');
          this.twitterUrl.set(master.appMain.twitterInformation || '#');
          this.instagramUrl.set(master.appMain.instagramInformation || '#');
        }
      },
    });
  }
}
